import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { registerApplication, unregisterApplication } from 'single-spa';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';
import { PlatformCommunicatorAuthService, } from 'src/app/shared/services/communicator/platform-communicator/platform-communicator.auth.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { CryptoVaultService } from 'src/app/shared/services/external/crypto-vault/crypto-vault.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IdentificationService } from 'src/app/shared/services/identification/identification.service';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { PlatformEndpointService } from 'src/app/shared/shared.module';
var MicroFirmlyApprovedComponent = /** @class */ (function () {
    function MicroFirmlyApprovedComponent(headerService, authService, navigationService, loaderService, abreCuentasService, endpointService, channelCommunicatorService, firmlyApprovedService, parametersService, bioCatchService, bitacoraService, identificationService, validationHelperService, postValidate, cipherService) {
        var _this = this;
        this.headerService = headerService;
        this.authService = authService;
        this.navigationService = navigationService;
        this.loaderService = loaderService;
        this.abreCuentasService = abreCuentasService;
        this.endpointService = endpointService;
        this.channelCommunicatorService = channelCommunicatorService;
        this.firmlyApprovedService = firmlyApprovedService;
        this.parametersService = parametersService;
        this.bioCatchService = bioCatchService;
        this.bitacoraService = bitacoraService;
        this.identificationService = identificationService;
        this.validationHelperService = validationHelperService;
        this.postValidate = postValidate;
        this.cipherService = cipherService;
        this.headerService.show(false, false, true);
        this.authSso = {
            session_id: this.authService.getSessionId(),
            token: this.authService.getSSOInformation().accessToken,
            transaction_id: this.abreCuentasService.getTransactionId(),
        };
        // this.setProductOffer();
        this.controlFlow = {
            nextStep: function (code) {
                _this.loaderService.forceHide();
                _this.navigationService.nextStep(code);
            },
            previousStep: function () { return _this.navigationService.previousStep(); },
            goToHomePage: function () { return _this.navigationService.goToLoginPage(); },
        };
        this.functions = {
            getIsLogin: function () { return _this.abreCuentasService.getPostlogin(); },
            downloadPdf: function (value) { return _this.channelCommunicatorService.getImpl().openPdf(value); },
            backpage: function () { return _this.channelCommunicatorService.getImpl().redirectToLoginView(); },
            setProductVincu: function (value) { return _this.abreCuentasService.setProductsVincu(value); },
        };
    }
    MicroFirmlyApprovedComponent.prototype.ngOnDestroy = function () {
        unregisterApplication('firmlyApproved');
    };
    MicroFirmlyApprovedComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loaderService.show('null');
                        return [4 /*yield*/, this.postValidate.solicitationId()];
                    case 1:
                        _a.sent();
                        registerApplication({
                            name: 'firmlyApproved',
                            app: function () { return System.import(_this.endpointService.MICROFRONTENDS.FIRMLY_APROVED); },
                            activeWhen: '/',
                            customProps: {
                                ssoProps: this.authSso,
                                controls: this.controlFlow,
                                loader: this.loaderService,
                                functions: this.functions,
                                abreCuentasService: this.abreCuentasService,
                                firmlyApprovedService: this.firmlyApprovedService,
                                channelCommunicatorService: this.channelCommunicatorService,
                                bioCatchService: this.bioCatchService,
                                bitacoraService: this.bitacoraService,
                                parametersService: this.parametersService,
                                products_firmlyApproved: this.parametersService.getSetting(OpEnum.APROBADOS_FIRME_CE),
                                identificationService: this.identificationService,
                                validationHelperService: this.validationHelperService,
                                navigationService: this.navigationService,
                                cipherService: this.cipherService,
                            },
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return MicroFirmlyApprovedComponent;
}());
export { MicroFirmlyApprovedComponent };
